module.exports = __webpack_public_path__ + "img/qunti.0210def6.png";